import React from 'react';
import L, { LatLngTuple, Map as LeafletMap } from 'leaflet';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';

export default function NGMapContainer({
    center,
    defaultZoom = 1.75,
    scrollWheelZoom = true,
    isLoading = false,
    isError = false,
    whenCreated,
    children,
}: React.PropsWithChildren<{
    controlsRef: React.MutableRefObject<any>;
    center: LatLngTuple;
    defaultZoom?: number;
    scrollWheelZoom?: boolean;
    isLoading?: boolean;
    isError?: boolean;
    whenCreated?: (map: LeafletMap) => void;
}>) {
    if (isLoading) return <p>Loading...</p>;
    if (isError) return <p>Error :(</p>;

    return (
        <MapContainer
            center={center}
            zoom={defaultZoom}
            scrollWheelZoom={scrollWheelZoom}
            className="flex-1"
            zoomControl={false}
            maxBounds={[
                [-90, -200],
                [90, 200],
            ]}
            maxBoundsViscosity={1.0}
            minZoom={1}
            ref={whenCreated}
            zoomSnap={0.5}
        >
            <ZoomControl position="bottomright" />
            <TileLayer
                attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
                url="https://api.maptiler.com/maps/dataviz/256/{z}/{x}/{y}@2x.png?key=wi0ZwfyRnTJmh0zc9ui8"
            />
            {children}
        </MapContainer>
    );
}
